import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { ImportedDataListItem } from '@modules/imported-data/types';
import type { ITableDataResponse, ITableState } from '@modules/tables/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import {
  IMPORTED_DATA_API_URL,
  IMPORTED_DATA_PERMISSIONS,
  IMPORTED_DATA_QUERY_KEY,
} from '@modules/imported-data/constants';
import { keepPreviousData } from '@tanstack/vue-query';

export default function useImportedDataListQuery(
  tableState: Ref<ITableState>,
): IContextQueryResult<ITableDataResponse<ImportedDataListItem>, Error> {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<ImportedDataListItem>>({
    queryKey: [IMPORTED_DATA_QUERY_KEY, tableState],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<ImportedDataListItem>>(
      IMPORTED_DATA_API_URL,
      tableState.value,
      {
        signal,
        permission: IMPORTED_DATA_PERMISSIONS.SHOW,
      },
    ),
    placeholderData: keepPreviousData,
  });
}
